import { useAuth } from '../../context/AuthContext';
import { Bars3Icon, ShieldCheckIcon } from '@heroicons/react/24/outline';
import { deriveNameFromEmail } from '../../utils/nameFromEmail';

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600&display=swap');
  .sh { height:60px; min-height:60px; background:#0f1123; border-bottom:1px solid rgba(255,255,255,.08); display:flex; align-items:center; justify-content:space-between; padding:0 24px; font-family:'Sora',sans-serif; flex-shrink:0; z-index:10; }
  .sh-left { display:flex; align-items:center; gap:8px; }
  .sh-breadcrumb { font-size:.8rem; color:rgba(255,255,255,.35); }
  .sh-sep  { color:rgba(255,255,255,.2); font-size:.8rem; }
  .sh-page { font-size:.82rem; color:rgba(255,255,255,.9); font-weight:600; }
  .sh-right { display:flex; align-items:center; gap:8px; }
  .sh-divider { width:1px; height:24px; background:rgba(255,255,255,.12); margin:0 4px; }
  .sh-user { display:flex; align-items:center; gap:10px; padding:5px 10px 5px 5px; border-radius:12px; cursor:pointer; border:1px solid transparent; transition:background .15s; }
  .sh-user:hover { background:rgba(255,255,255,.07); border-color:rgba(255,255,255,.1); }
  .sh-avatar { width:32px; height:32px; border-radius:10px; background:linear-gradient(135deg,#f59e0b,#ef4444); display:flex; align-items:center; justify-content:center; font-size:.75rem; font-weight:700; color:white; flex-shrink:0; }
  .sh-name { font-size:.8rem; font-weight:600; color:rgba(255,255,255,.9); }
  .sh-role { font-size:.68rem; color:rgba(255,255,255,.4); margin-top:2px; }
  .sh-badge { display:inline-flex; align-items:center; gap:5px; background:rgba(245,158,11,.15); color:#fbbf24; border:1px solid rgba(245,158,11,.3); border-radius:99px; padding:3px 10px; font-size:.68rem; font-weight:700; }
  .sh-badge svg { width:12px; height:12px; stroke-width:2; }
  .sh-logout { padding:7px 14px; background:rgba(239,68,68,.15); color:#f87171; border:1px solid rgba(239,68,68,.3); border-radius:9px; font-size:.78rem; font-weight:600; font-family:'Sora',sans-serif; cursor:pointer; transition:background .15s; }
  .sh-logout:hover { background:rgba(239,68,68,.3); }
  .sh-hamburger { display:none; width:36px; height:36px; border:none; background:transparent; cursor:pointer; }
  .sh-hamburger svg { width:20px; height:20px; stroke:rgba(255,255,255,.7); stroke-width:1.7; }
  @media (max-width:768px) {
    .sh { padding:0 16px; }
    .sh-hamburger { display:flex; align-items:center; justify-content:center; }
    .sh-breadcrumb,.sh-sep,.sh-badge { display:none; }
    .sh-name,.sh-role { display:none; }
    .sh-user { padding:4px; }
    .sh-divider { display:none; }
  }
`;

const getInitials = (name='') => name.split(' ').map(n=>n[0]).join('').toUpperCase().slice(0,2)||'SA';

export default function SuperHeader({ onMenuClick }) {
  const { user, logout } = useAuth();
  const displayName = user?.name || deriveNameFromEmail(user?.email) || 'Super Admin';
  return (
    <>
      <style>{css}</style>
      <header className="sh">
        <div className="sh-left">
          <button className="sh-hamburger" onClick={onMenuClick}><Bars3Icon /></button>
          <span className="sh-breadcrumb">School Portal</span>
          <span className="sh-sep">/</span>
          <span className="sh-page">Super Admin</span>
          <span className="sh-badge"><ShieldCheckIcon />Super Admin</span>
        </div>
        <div className="sh-right">
          <div className="sh-user">
            <div className="sh-avatar">{getInitials(displayName)}</div>
            <div>
              <div className="sh-name">{displayName}</div>
              <div className="sh-role">Full System Access</div>
            </div>
          </div>
          <div className="sh-divider" />
          <button className="sh-logout" onClick={logout}>Logout</button>
        </div>
      </header>
    </>
  );
}